const LoadingSpinner = ({size = 7, color = 'white'}) => {

    return (
        <div style={{borderTopColor: 'transparent'}}
             className={`w-${size} h-${size} border-4 border-${color} border-solid rounded-full animate-spin`}/>
    );
}

export default LoadingSpinner;